let moduleSwitcherHeight = 56;

/**
 * Outlook Lite implements the module switcher natively, therefore, no space should be
 * reserved for the module switcher when rendering OWA Mini. By replacing the fixed 56px
 * with a CSS variable, we can adjust the height at runtime and override the default with 0.
 *
 * @param newHeight Height to override the default module switcher height.
 * Currently set to 0 in `NativeModuleSwitcher.tsx`
 */
export function overrideModuleSwitcherHeight(newHeight: number): void {
    moduleSwitcherHeight = newHeight;
    document.body.style.setProperty('--module-switcher-height', `${newHeight}px`);
}

export function getModuleSwitcherHeight(): number {
    return moduleSwitcherHeight;
}
